import {
    MILITARY_VARIANT,
    STC_VARIANT,
    collection,
    isMilitaryEnabled,
    parentTypeFor,
} from "../_variants/index.js";
import {
    addEADT,
    changeLinkedRevision,
    editEadtData,
    linkEadtToEAR
} from "./actions";

import { get } from "lodash";

const headers = [{
    "headerName": "Number",
    "field": "Number"
}, {
    "headerName": "Name",
    "field": "Name",
}, {
    "headerName": "Linked Revision",
    fieldGetter({ pageItem }) {
        return `Links.${pageItem.ID}`
    },
    valueFormatter(params) {
        let linkedRev = get(params.data, params.column.colId);
        let revision = get(params.data, `Revisions.${linkedRev}`);
        if (!!revision) {
            return revision.Revision === params.data.Revision ? revision.Revision : `${revision.Revision} (Revision ${params.data.Revision} Available)`
        } else return params.data.Revision
    }
}, {
    "headerName": "Manufacturer",
    "field": "Manufacturer"
}, {
    "headerName": "EADT Classification",
    "field": "EADTClassification"
}];

/**
 * Build the attachable-table descriptor for the EADT register that matches
 * the supplied variant.
 *
 * @param {import("../_variants/index.js").Variant} variant
 */
export const makeEADTAttachable = (variant) => {
    const isMilitary = variant.key === "military";
    const labelSingular = isMilitary ? "Military EADT" : "EADT";
    const labelPlural = isMilitary ? "Military EADTs" : "EADTs";
    const eadtParentType = parentTypeFor(variant, "EADTs");
    const eadtCollection = collection(variant, "EADTs");

    const actions = [{
        "label": `Add ${labelSingular}`,
        "action": addEADT,
        "show": ({ meta }) => {
            return [[
                ["EARs"].includes(meta?.ParentType),
                `${labelSingular}s cannot be added here, they must be linked.`
            ]]
        }
    }, {
        "label": `Link ${labelSingular}`,
        action: linkEadtToEAR
    }];


    const rowActions = [{
        "label": `View ${labelSingular}`,
        action({ router, rowItem }) {
            router.push(`/Database/${eadtParentType}/${rowItem.ID}`)
        }
    }, {
        "label": "View Manufacturer",
        action({ router, rowItem }) {
            router.push(`/Database/Manufacturers/${rowItem.ManufacturerID}`)
        }
    }, {
        "break": true,
        "label": `Edit ${labelSingular}`,
        "action": editEadtData
    }, {
        "label": "Change Linked Revision",
        "action": changeLinkedRevision
    }];

    return {
        "label": labelPlural,
        "key": eadtParentType,
        "location": `${eadtCollection}/`,
        actions,
        rowActions,
        headers
    };
};

export const eadtAttachable = makeEADTAttachable(STC_VARIANT);
export const militaryEADTAttachable = isMilitaryEnabled() ? makeEADTAttachable(MILITARY_VARIANT) : null;


